<template>
    <div class="order-container">
        <head-bar title="提交订单" :fixed="true"></head-bar>
        <!-- 配送方式 -->
        <div class="distribution-container">
            <div class="decorate-bar"></div>
            <div class="menu-item" @click="distributionSheetVisible = true">
                <div class="meun-left">
                    <span>配送方式</span>
                </div>
                <div class="meun-right">
                    <span>{{ currentDistributionType.name }}</span>
                </div>
            </div>
            <!-- 用户地址 -->
            <div
                class="distribution-type-express"
                v-show="
                    currentDistributionType.type == distributionTypeMap.express
                "
            >
                <div
                    class="address-box"
                    @click="addressSheetVisible = true"
                    v-show="userAddressList.length == 0"
                >
                    <div class="addrss-info">
                        <span>添加地址</span>
                    </div>
                    <div class="linkman-info">
                        <span>{{ currentUserAddress.receiver }}</span>
                        <span class="space-t">{{
                            currentUserAddress.receiverPhone
                        }}</span>
                    </div>
                </div>
                <div
                    class="address-box"
                    v-show="userAddressList.length != 0"
                    @click="addressSheetVisible = true"
                >
                    <div class="addrss-info">
                        <span>
                            {{ currentUserAddress.province }}
                            {{ currentUserAddress.city }}
                            {{ currentUserAddress.district }}
                            {{ currentUserAddress.detailAddress }}
                        </span>
                    </div>
                    <div class="linkman-info">
                        <span>{{ currentUserAddress.receiver }}</span>
                        <span class="space-t">{{
                            currentUserAddress.receiverPhone
                        }}</span>
                    </div>
                </div>
                <div class="express-info-box" v-show="expressList.length != 0">
                    <div
                        class="info-content"
                        @click="expressSheetVisible = true"
                    >
                        <div class="express-left-info">
                            <div class="info-text">
                                <div>
                                    <span>物流快递</span>
                                </div>
                            </div>
                        </div>
                        <div class="express-right-info">
                            <div class="exporess-info-space">
                                <span>{{
                                    currentExpressInfo.shipperName
                                }}</span>
                                <span
                                    v-if="
                                        !isEmpty(priceInfo.orderShipperPriceVo)
                                    "
                                >
                                    <em
                                        v-if="
                                            priceInfo.orderShipperPriceVo
                                                .expressPriceType ==
                                                expressTypeMap.difference
                                        "
                                        >&nbsp;&nbsp;&nbsp;&nbsp;需补差&nbsp;&nbsp;<b
                                            class="orgin-color"
                                            >{{ priceInfo.expressAmount }}</b
                                        ></em
                                    >
                                    <em
                                        v-if="
                                            priceInfo.orderShipperPriceVo
                                                .expressPriceType ==
                                                expressTypeMap.activity ||
                                                priceInfo.orderShipperPriceVo
                                                    .expressPriceType ==
                                                    expressTypeMap.free
                                        "
                                        >&nbsp;&nbsp;&nbsp;&nbsp;满¥&nbsp;&nbsp;{{
                                            priceInfo.orderShipperPriceVo
                                                .freeShipperThreshold
                                        }}包邮</em
                                    >
                                </span>
                            </div>
                            <div class="exporess-info-space">
                                <span
                                    >{{
                                        currentExpressInfo.timeScope
                                    }}&nbsp;前付款</span
                                >
                            </div>
                            <div class="exporess-info-space">
                                <span>{{
                                    currentExpressInfo.estimatedDeliveryTime
                                }}</span>
                            </div>
                            <div
                                class="exporess-info-space"
                                v-if="!isEmpty(priceInfo.orderShipperPriceVo)"
                            >
                                <span
                                    v-if="
                                        priceInfo.orderShipperPriceVo
                                            .expressPriceType ==
                                            expressTypeMap.difference
                                    "
                                    >{{
                                        priceInfo.orderShipperPriceVo
                                            .choiceExpressName
                                    }}¥&nbsp;</span
                                >
                                <span
                                    v-if="
                                        priceInfo.orderShipperPriceVo
                                            .expressPriceType ==
                                            expressTypeMap.difference
                                    "
                                    >{{
                                        priceInfo.orderShipperPriceVo
                                            .choiceExpressPrice
                                    }}
                                </span>
                                <span
                                    v-if="
                                        priceInfo.orderShipperPriceVo
                                            .expressPriceType ==
                                            expressTypeMap.difference
                                    "
                                    >&nbsp;&nbsp;{{
                                        priceInfo.orderShipperPriceVo
                                            .deductionExpressName
                                    }}¥&nbsp;</span
                                >
                                <span
                                    v-if="
                                        priceInfo.orderShipperPriceVo
                                            .expressPriceType ==
                                            expressTypeMap.difference
                                    "
                                    >{{
                                        priceInfo.orderShipperPriceVo
                                            .expressDeductionExpressPrice
                                    }}</span
                                >
                            </div>
                            <div>
                                <span>{{ currentExpressInfo.remark }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 到付 -->
                <div
                    class="menu-item"
                    v-if="hasFreight"
                    @click="showFreight = true"
                >
                    <div class="meun-left">
                        <span>运费/{{ isFreight ? "到付" : "寄付" }}</span>
                    </div>
                    <div class="meun-right">
                        <span>{{ isFreight ? "到付" : "寄付" }}</span>
                    </div>
                </div>
                <!-- 到付 -->
                <!-- 加急 -->
                <div
                    class="urgent-info-box"
                    @click="urgentSheetVisible = true"
                    v-show="currentExpressInfo.isShowUrgentButton"
                >
                    <div class="info-content">
                        <div class="express-left-info">
                            <div class="info-text">
                                <div>
                                    <span>申请加急今日发货</span>
                                </div>
                            </div>
                        </div>
                        <div class="express-right-info">
                            <div class="exporess-info-space">
                                <span>{{
                                    isUrgent ? "已申请" : "未申请"
                                }}</span>
                            </div>
                            <div class="exporess-info-space">
                                <span
                                    >预计{{
                                        currentExpressInfo.urgentEstimatedDeliveryTime
                                    }}送达</span
                                >
                            </div>
                            <div class="exporess-info-space">
                                <span>加急不成功专属客服会联系</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 加急 -->
                <div class="express-hint">
                    <span>承诺时间内未送达,赠送一张5元优惠券</span>
                </div>
            </div>
            <!-- 用户地址 -->
            <!-- 商家店铺 -->
            <div
                class="distribution-type-store"
                v-show="
                    currentDistributionType.type == distributionTypeMap.delivery
                "
            >
                <div
                    class="address-box"
                    @click="userStoreSheetVisible = true"
                    v-show="userStoreList.length == 0"
                >
                    <div class="addrss-info">
                        <span>添加地址</span>
                    </div>
                    <div class="linkman-info">
                        <span>{{ currentUserStore.receiver }}</span>
                        <span class="space-t">{{
                            currentUserStore.receiverPhone
                        }}</span>
                    </div>
                </div>
                <div
                    class="address-box"
                    v-show="userStoreList.length != 0"
                    @click="userStoreSheetVisible = true"
                >
                    <div class="addrss-info">
                        <span>
                            {{ currentUserStore.province }}
                            {{ currentUserStore.city }}
                            {{ currentUserStore.district }}
                            {{ currentUserStore.detailAddress }}
                            {{ currentUserStore.houseNo }}
                        </span>
                    </div>
                    <div class="linkman-info">
                        <span>{{ currentUserStore.receiver }}</span>
                        <span class="space-t">{{
                            currentUserStore.receiverPhone
                        }}</span>
                    </div>
                </div>
                <div class="arrival_time_info">
                    <div class="info-content">
                        <div class="timer-left-info">
                            <div class="info-text">
                                <div>
                                    <span>送货上门</span>
                                </div>
                            </div>
                        </div>
                        <div class="timer-right-info">
                            <div class="time-info-space">
                                <span
                                    >{{
                                        deliveryTimeInfo.timeScope
                                    }}&nbsp;前付款</span
                                >
                                <em
                                    v-if="
                                        priceInfo.orderShipperPriceVo
                                            .expressPriceType ==
                                            expressTypeMap.activity ||
                                            priceInfo.orderShipperPriceVo
                                                .expressPriceType ==
                                                expressTypeMap.free
                                    "
                                    >&nbsp;&nbsp;满¥&nbsp;&nbsp;{{
                                        priceInfo.orderShipperPriceVo
                                            .freeShipperThreshold
                                    }}免运费&nbsp;</em
                                >
                            </div>
                            <div class="time-info-space">
                                <span
                                    >预计&nbsp;{{
                                        deliveryTimeInfo.estimatedDeliveryTime
                                    }}&nbsp;到店</span
                                >
                            </div>
                            <div class="time-info-space">
                                <span
                                    >&nbsp;预计{{
                                        deliveryTimeInfo.arrivalTime
                                    }}送达</span
                                >
                            </div>
                            <div>
                                <span>{{ deliveryTimeInfo.remark }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="time-hint">
                        <span>承诺时间内未送达,赠送一张1元优惠券</span>
                    </div>
                </div>
            </div>
            <!-- 商家店铺 -->
            <!-- 自用店铺 -->
            <div
                class="distribution-type-base"
                v-show="
                    currentDistributionType.type == distributionTypeMap.store
                "
            >
                <div class="address-box">
                    <div class="addrss-info">
                        <span>{{
                            storeInfoConfigInfo.offlineStoreAddress
                        }}</span>
                    </div>
                    <div class="linkman-info">
                        <span>{{ storeInfoConfigInfo.offlineStoreName }}</span>
                        <span class="space-t">{{
                            storeInfoConfigInfo.offlineStoreTel
                        }}</span>
                    </div>
                </div>
                <div class="arrival_time_info">
                    <div class="info-content height-115">
                        <div class="timer-left-info height-115">
                            <div class="info-text">
                                <div>
                                    <span>门店自提</span>
                                </div>
                            </div>
                        </div>
                        <div class="timer-right-info">
                            <div class="time-info-space">
                                <span
                                    >{{
                                        deliveryTimeInfo.timeScope
                                    }}&nbsp;前付款</span
                                >
                            </div>
                            <div class="time-info-space">
                                <span
                                    >预计&nbsp;{{
                                        deliveryTimeInfo.estimatedDeliveryTime
                                    }}&nbsp;到店</span
                                >
                            </div>
                            <div>
                                <span>{{ deliveryTimeInfo.remark }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 自用店铺 -->
            <!-- 自用仓库 -->
            <div
                class="distribution-type-base"
                v-show="
                    currentDistributionType.type ==
                        distributionTypeMap.warehouse
                "
            >
                <div class="address-box">
                    <div class="addrss-info">
                        <span>{{
                            $config.WAREHOUSE_ADDRESS_INFO.detailsAddress
                        }}</span>
                    </div>
                    <div class="linkman-info">
                        <span>{{
                            $config.WAREHOUSE_ADDRESS_INFO.addressName
                        }}</span>
                        <span class="space-t">{{
                            $config.WAREHOUSE_ADDRESS_INFO.addressTel
                        }}</span>
                    </div>
                </div>
                <div class="arrival_time_info">
                    <div class="info-content height-115">
                        <div class="timer-left-info height-115">
                            <div class="info-text">
                                <div>
                                    <span>李朗自提</span>
                                </div>
                            </div>
                        </div>
                        <div class="timer-right-info">
                            <div class="time-info-space">
                                <span
                                    >{{
                                        deliveryTimeInfo.timeScope
                                    }}&nbsp;前付款</span
                                >
                            </div>
                            <div class="time-info-space">
                                <span
                                    >预计&nbsp;{{
                                        deliveryTimeInfo.estimatedDeliveryTime
                                    }}&nbsp;到达</span
                                >
                            </div>
                            <div>
                                <span>{{ deliveryTimeInfo.remark }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 自用仓库 -->
        </div>
        <!-- 配送方式 -->
        <!-- 菜单选项 -->
        <div class="meuns-container">
            <div class="menu-item" @click="linkmanSheetVisible = true">
                <div class="meun-left">
                    <span>下单联系人</span>
                </div>
                <div class="meun-right">
                    <span>{{ currentLinkman.linkmanName | ellipsis(3) }}</span>
                    <span>&nbsp;{{ currentLinkman.linkmanPhone }}</span>
                </div>
            </div>
            <div class="menu-item" @click="openInvoiceSheet">
                <div class="meun-left">
                    <span>是否开发票</span>
                </div>
                <div class="meun-right">
                    <span v-show="hasInvoice == false">暂无发票</span>
                    <span v-show="hasInvoice && needInvoice">{{
                        invoiceInfo.companyName | ellipsis(8)
                    }}</span>
                    <span v-show="hasInvoice && !needInvoice">不开发票</span>
                </div>
            </div>
            <div class="menu-item" @click="discountSheetVisible = true">
                <div class="meun-left">
                    <span>优惠券</span>
                </div>
                <div class="meun-right">
                    <span>¥{{ priceInfo.discountAmount }}</span>
                </div>
            </div>
            <!-- <div class="menu-item" @click="payModeSheetVisible = true">
                <div class="meun-left">
                    <span>支付方式</span>
                </div>
                <div class="meun-right">
                    <span>{{ currentPayMode.name }}</span>
                </div>
            </div> -->
        </div>
        <!-- 商品信息 -->
        <!-- 留言框 -->
        <div class="message-container">
            <van-field
                v-model="customNumber"
                @input="customNumberChange"
                rows="1"
                autosize
                label="自定义订单编码"
                type="textarea"
                maxlength="30"
                placeholder="请输入自定义订单编码"
                show-word-limit
            />
            <div class="codes_text">
                <span>扫描样品拣货标签可查看自定义订单编码</span>
                <br />
                <span>（整包装无拣货标签）</span>
            </div>
        </div>
        <!-- 留言框 -->
        <!-- 留言框 -->
        <div class="message-container">
            <van-field
                v-model="message"
                rows="2"
                autosize
                label="备注"
                type="textarea"
                maxlength="200"
                placeholder="请输入备注"
                show-word-limit
            />
        </div>
        <!-- 留言框 -->
        <div class="product-container">
            <ul class="product-list">
                <li
                    class="product-item"
                    v-show="index < productMinlen"
                    v-for="(item, index) in productList"
                    :key="index"
                >
                    <div class="product-name">
                        <template v-if="Array.isArray(item.product.labelList)">
                            <span
                                class="lable-item"
                                :key="index"
                                :style="{
                                    backgroundColor: label.backgroundColor,
                                    color: label.fontColor,
                                }"
                                v-for="(label, index) in item.product.labelList"
                                >{{ label.labelName }}</span
                            >
                        </template>
                        <span>{{ item.product.goodsName }}</span>
                    </div>
                    <div class="product-param">
                        <span>{{ item.product.factoryCode }}</span>
                    </div>
                    <div class="product-param">
                        <span>{{ item.product.brand.brandName }}</span>
                        <span class="batch" v-if="item.product.hasBathNo"
                            >批次&nbsp;&nbsp;&nbsp;{{
                                item.product.stock.batchList[0].batchNo
                            }}</span
                        >
                    </div>
                    <div class="product-price-info">
                        <div class="info-1">
                            <span>￥{{ item.unitPrice }}</span>
                        </div>
                        <div class="info-1">
                            <em>×</em>
                            <span>{{ item.quantity }}pcs</span>
                        </div>
                        <div class="info-2">
                            <span>¥ {{ item.price }}</span>
                        </div>
                    </div>
                </li>
            </ul>
            <div
                class="product-more"
                @click="showMoreProduct"
                v-show="productList.length > minHiderNumber"
            >
                <span>{{
                    productMinlen == minHiderNumber ? "展开" : "收起"
                }}</span>
                <i
                    class="more-arrow-icon"
                    :class="{
                        'up-arrow-icon': productMinlen != minHiderNumber,
                    }"
                ></i>
            </div>
        </div>
        <!-- 商品信息 -->
        <!-- 价格信息 -->
        <div class="price-container">
            <div class="price-item">
                <div class="price-info-name">
                    <span>商品总价</span>
                </div>
                <div class="price-number">
                    <span>¥ {{ priceInfo.productAmount }}</span>
                </div>
            </div>
            <div class="price-item">
                <div class="price-info-name">
                    <span>运费</span>
                </div>
                <div class="price-number">
                    <span>¥ {{ priceInfo.expressAmount }}</span>
                </div>
            </div>
            <div class="price-item">
                <div class="price-info-name">
                    <span>运费减免</span>
                </div>
                <div class="price-number">
                    <span>-¥ {{ priceInfo.expressDiscountAmount }}</span>
                </div>
            </div>
            <div class="price-item">
                <div class="price-info-name">
                    <span>优惠减免</span>
                </div>
                <div class="price-number">
                    <span>-¥ {{ priceInfo.discountAmount }}</span>
                </div>
            </div>
            <div class="price-item">
                <div class="price-info-name">
                    <span>应付</span>
                </div>
                <div class="price-number">
                    <span>¥ {{ priceInfo.payAmount }}</span>
                </div>
            </div>
        </div>
        <!-- 价格信息 -->
        <div class="settlement-bar">
            <div class="price-info">
                <span class="t-1">实际支付:</span>
                <span class="t-2">¥</span>
                <span class="t-3">{{ priceInfo.payAmount }}</span>
            </div>
            <div class="sumbit-btn needsclick" @click="createOrder">
                <span>提交订单</span>
            </div>
        </div>
        <!-- 配送方式上拉菜单 -->
        <van-action-sheet
            v-model="distributionSheetVisible"
            :actions="distributionTypeList"
            @select="
                (value) => {
                    selectDistributionType(value, true);
                }
            "
            cancel-text="取消"
            description="选择配送方式"
        />
        <!-- 配送方式上拉菜单 -->
        <!-- 支付方式上拉菜单 -->
        <van-action-sheet
            v-model="payModeSheetVisible"
            :actions="payModeTypeList"
            @select="selectPayMode"
            cancel-text="取消"
            description="选择支付方式"
        />
        <!-- 支付方式上拉菜单 -->
        <!-- 用户地址 -->
        <van-action-sheet v-model="addressSheetVisible" title="选择地址">
            <ul class="user-address-list">
                <li
                    class="address-item"
                    @click="selectUserAddress(item)"
                    v-for="(item, index) in userAddressList"
                    :key="index"
                >
                    <div class="addrss-info">
                        <span
                            >{{ item.province }}{{ item.city }}{{ item.district
                            }}{{ item.detailAddress }}</span
                        >
                    </div>
                    <div class="linkman-info">
                        <span>{{ item.receiver }}</span>
                        <span style="padding-right: 5px" class="space-t">{{
                            item.receiverPhone
                        }}</span>
                        <van-tag type="primary" v-if="item.defaultFlag"
                            >默认</van-tag
                        >
                    </div>
                </li>
            </ul>
            <!-- 空数据 -->
            <div class="empty-box" v-show="userAddressList.length == 0">
                <empty-data
                    iconText="暂无收货地址"
                    :iconSrc="emptyInvoiceIcon"
                    :iconSize="'smallest'"
                    :paddingBottom="0.5"
                    :paddingTop="0.5"
                ></empty-data>
            </div>
            <!-- 空数据 -->
            <div
                class="common-btn"
                @click="$router.push('/user/address/logistics')"
                v-show="userAddressList.length < 50"
            >
                <span>添加快递地址</span>
            </div>
        </van-action-sheet>
        <!-- 用户地址 -->
        <!-- 用户店铺地址 -->
        <van-action-sheet
            v-model="userStoreSheetVisible"
            title="选择送货上门地址"
        >
            <ul class="user-address-list">
                <li
                    class="address-item"
                    @click="selectUserStore(item)"
                    v-for="(item, index) in userStoreList"
                    :key="index"
                >
                    <div class="addrss-info">
                        <span
                            >{{ item.province }}{{ item.city }}{{ item.district
                            }}{{ item.detailAddress }}{{ item.houseNo }}</span
                        >
                    </div>
                    <div class="linkman-info">
                        <span>{{ item.receiver }}</span>
                        <span style="padding-right: 5px" class="space-t">{{
                            item.receiverPhone
                        }}</span>
                        <van-tag
                            type="primary"
                            v-if="item.defaultFlag && item.status == 1"
                            >默认</van-tag
                        >
                        <van-tag color="#CCC" v-if="item.status != 1"
                            >已失效</van-tag
                        >
                    </div>
                </li>
            </ul>
            <!-- 空数据 -->
            <div class="empty-box" v-show="userStoreList.length == 0">
                <empty-data
                    iconText="暂无送货上门地址"
                    :iconSrc="emptyInvoiceIcon"
                    :iconSize="'smallest'"
                    :paddingBottom="0.5"
                    :paddingTop="0.5"
                ></empty-data>
            </div>
            <!-- 空数据 -->
            <div
                class="common-btn"
                @click="goToStoreAddressEdit"
                v-show="userStoreList.length < 50"
            >
                <span>添加送货上门地址</span>
            </div>
        </van-action-sheet>
        <!-- 用户店铺地址 -->
        <!-- 联系人 -->
        <van-action-sheet v-model="linkmanSheetVisible" title="选择联系人">
            <ul class="linkman-list">
                <li
                    class="linkman-item"
                    @click="selectLinkman(item)"
                    v-for="(item, index) in linkmanList"
                    :key="index"
                >
                    <span>{{ item.linkmanName }}</span>
                    <em style="padding-right: 5px">{{ item.linkmanPhone }}</em>
                    <van-tag type="primary" v-if="item.defaultFlag"
                        >默认</van-tag
                    >
                </li>
            </ul>
            <!-- 空数据 -->
            <div class="empty-box" v-show="linkmanList.length == 0">
                <empty-data
                    iconText="暂无下单联系人"
                    :iconSrc="emptyLinkmanIcon"
                    :iconSize="'smallest'"
                    :paddingBottom="0.5"
                    :paddingTop="0.5"
                ></empty-data>
            </div>
            <!-- 空数据 -->
            <div
                class="common-btn"
                @click="$router.push('/user/linkman/edit')"
                v-show="linkmanList.length < 10"
            >
                <span>添加联系人</span>
            </div>
        </van-action-sheet>
        <!-- 联系人 -->
        <!-- 发票 -->
        <van-action-sheet v-model="invoiceSheetVisible" title="发票">
            <div
                class="invoice-info-box"
                :class="{ padding_bottom: !needInvoice }"
                v-show="hasInvoice"
            >
                <div class="invoce-select">
                    <span
                        class="select-item margin-right"
                        @click="needInvoice = true"
                        :class="{ active: needInvoice == true }"
                        >开发票</span
                    >
                    <span
                        class="select-item"
                        @click="needInvoice = false"
                        :class="{ active: needInvoice == false }"
                        >不开发票</span
                    >
                </div>
                <div class="invoice-info-list" v-show="needInvoice">
                    <ul class="invoice-info-ul">
                        <li
                            class="invoice-info-item"
                            v-for="(item, index) in invoiceList"
                            :key="index"
                        >
                            <div class="icon">
                                <div class="icon-wrap">
                                    <van-checkbox
                                        checked-color="#4BC227"
                                        v-model="item.selected"
                                        icon-size="20px"
                                        @click="
                                            (checked) =>
                                                invoiceSelectChange(
                                                    checked,
                                                    item
                                                )
                                        "
                                    >
                                    </van-checkbox>
                                </div>
                            </div>
                            <div class="invoice-text">
                                <div class="company-name">
                                    <span>{{
                                        item.companyName | ellipsis(15)
                                    }}</span>
                                    <i
                                        class="default-icon"
                                        v-if="item.isDefault"
                                        >默认</i
                                    >
                                </div>
                                <div class="tax-number">
                                    <span>{{ item.taxNo }}</span>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span>{{ item.invoiceStatusDesc }}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 空数据 -->
            <div class="empty-box" v-show="!hasInvoice">
                <empty-data
                    iconText="暂无开票资料"
                    :iconSrc="emptyAddrssIcon"
                    :iconSize="'smallest'"
                    :paddingBottom="0.5"
                    :paddingTop="0.5"
                ></empty-data>
            </div>
            <!-- 空数据 -->
            <div class="btn-group margin-top" v-show="needInvoice">
                <div
                    class="btn-item"
                    @click="
                        $router.push({
                            path: '/user/invoice/infoEdit',
                            query: {
                                from: '/order',
                            },
                        })
                    "
                    v-show="hasInvoice"
                >
                    <span>+创建发票信息</span>
                </div>
                <div
                    class="btn-item margin-bottom"
                    @click="
                        $router.push({
                            path: '/user/invoice/infoEdit',
                            query: {
                                form: '/order',
                            },
                        })
                    "
                    v-show="!hasInvoice"
                >
                    <span>+创建发票信息</span>
                </div>
            </div>
        </van-action-sheet>
        <!-- 发票 -->
        <!-- 优惠券 -->
        <van-action-sheet v-model="discountSheetVisible" title="优惠券">
            <ul class="coupon-list">
                <counpon-item
                    v-for="(item, index) in couponList"
                    :key="index"
                    :coupon-info="item"
                    @use="selectCoupon"
                ></counpon-item>
            </ul>
            <div class="empty-box" v-show="couponList.length == 0">
                <empty-data
                    iconText="暂无可用优惠券"
                    :iconSrc="emptyCouponIcon"
                    :iconSize="'smallest'"
                    :paddingBottom="0.5"
                    :paddingTop="0.5"
                ></empty-data>
            </div>
            <div
                class="common-btn"
                @click="nonuseConponInfo"
                v-show="couponList.length >= 1"
            >
                <span>不使用优惠券</span>
            </div>
        </van-action-sheet>
        <!-- 优惠券 -->
        <!-- 快递 -->
        <van-action-sheet v-model="expressSheetVisible" title="快递信息">
            <div class="express-sheet-box">
                <ul class="express-data-list">
                    <li
                        class="express-item"
                        @click="selectExpress(item)"
                        v-for="(item, index) in expressList"
                        :key="index"
                    >
                        {{ item.shipperName }}
                    </li>
                </ul>
            </div>
        </van-action-sheet>
        <!-- 快递 -->

        <!-- 快递 -->
        <van-action-sheet v-model="showFreight" title="快递结算方式">
            <div class="express-sheet-box">
                <ul class="express-data-list">
                    <li class="express-item" @click="freightChange(true)">
                        到付
                    </li>
                    <li class="express-item" @click="freightChange(false)">
                        寄付
                    </li>
                </ul>
            </div>
        </van-action-sheet>
        <!-- 快递 -->

        <!-- 加急 -->
        <van-action-sheet v-model="urgentSheetVisible" title="加急发货">
            <div class="express-sheet-box">
                <ul class="express-data-list">
                    <li class="express-item" @click="urgentChange(true)">
                        加急发货
                    </li>
                    <li class="express-item" @click="urgentChange(false)">
                        无需加急
                    </li>
                </ul>
            </div>
        </van-action-sheet>
        <!-- 加急 -->
    </div>
</template>
<script>
import Vue from "vue";
import { ActionSheet, Toast, Field, Dialog, Tag, Checkbox } from "vant";
import {
    setProductListFieldName,
    hasCouponType,
    findOptimalCoupon,
    setPostageCouponListStatus,
} from "./helper/order";
import EmptyData from "@/components/EmptyData";
import HeadBar from "@/components/HeadBar.vue";
import CounponItem from "@/views/user/coupon/children/CounponItem";
import { isEmpty, isEncode } from "@/utils/validation";
//检测商品是否含有批次吗
function checkProductHasBatch(productList = []) {
    let temp = [];
    if (!Array.isArray(productList)) return [];
    productList.forEach((item) => {
        let { product } = item;
        let { batchList = [] } = product.stock;
        product.hasBathNo = !isEmpty(batchList);
        item.product = product;
        temp.push(item);
    });
    return temp;
}

Vue.use(ActionSheet)
    .use(Toast)
    .use(Field)
    .use(Tag)
    .use(Checkbox);

//配送类型
const coupon_check_type = {
    list: 1,
    distribution: 2,
    reject: 3,
    btnSelect: 4,
};
//优惠券检测类型
const coupon_check_status = {
    optimal: 1,
    select: 2,
    nonuse: 3,
}
const SOURCE_CART = 1;
//商品最小隐藏数
const min_hide_number = 3;
//配送方式类型
const distribution_type_map = {
    express: 0, //快递
    store: 1, //到店自提
    delivery: 2, //送货上门
    ml: 3, //美隆送货
    warehouse: 4, //李朗自提
};

//支付类型
const pay_type_map = {
    online: 0,
    offline: 1,
};

//是否需要开发票
const invoice_type_map = {
    need: 1,
    needless: 0,
};

//快递类型
const express_type_map = {
    normal: 0, //正常
    activity: 10, //活动
    difference: 20, //补差
    free: 100, //包邮
};

//用户详细地址
const address_type_user = 0;
//用户店铺店址
const address_type_store = 1;

function getDefaultData(source, field = "default") {
    if (!Array.isArray(source)) return null;
    let defaultData = {};
    source.forEach((item) => {
        if (item[field]) {
            defaultData = item;
        }
    });
    return defaultData;
}

/**
 *
 * @param {[]} source 配送方式列表
 * @description 获取默认配置列表
 */
function getDefaultDistributionInfo(source = [], currentDistributionType = "") {
    let data = {
        distributionType: distribution_type_map.express,
        invoiceDemand: invoice_type_map.needless,
        distributionDefaultHint: "若遇法定节假日，顺延收发货时间",
        name: "快递",
        item: {},
    };
    source.forEach((item) => {
        if (isEmpty(currentDistributionType)) {
            if (item.usableDefaultType) {
                data.name = item.distributionDesc;
                data.distributionType = item.distributionId;
                data.invoiceDemand = item.needOpenInvoice
                    ? invoice_type_map.need
                    : invoice_type_map.needless;
                data.item = item;
            }
        } else {
            if (item.type == currentDistributionType) {
                data.name = item.distributionDesc;
                data.distributionType = item.distributionId;
                data.invoiceDemand = item.needOpenInvoice
                    ? invoice_type_map.need
                    : invoice_type_map.needless;
                data.item = item;
            }
        }
    });
    return data;
}

/**
 *
 *
 * @param {array} source 数据列表
 * @description 设置选中属性
 */
function setSelectedAttrBute(source, field = "defaultFlag") {
    if (Array.isArray(source)) {
        return source.map((item) => {
            if (item[`${field}`]) {
                item.selected = true;
            } else {
                item.selected = false;
            }
            return item;
        });
    } else {
        return [];
    }
}

function setDistributionTypeListAttrBute(source = []) {
    if (Array.isArray(source)) {
        return source.map((item) => {
            if (
                isEmpty(item.iconHint) ||
                (!item.iconIsShow &&
                    (item.distributionId == distribution_type_map.delivery ||
                        item.distributionId == distribution_type_map.store))
            ) {
                item.subname = "限华强北内";
            } else if (item.distributionId == distribution_type_map.ml) {
                item.subname = "";
            } else {
                item.subname = item.iconHint;
            }
            if (!item.iconIsShow) {
                item.subname = "";
            }
            if (item.distributionId == distribution_type_map.delivery) {
                item.subname = "限华强北内";
            }
            item.type = item.distributionId;
            item.name = item.distributionDesc;
            return item;
        });
    } else {
        return [];
    }
}

/**
 * @description 获取用户默认地址
 */
function getDefaultAddress(addressList = []) {
    let defaultAddress = addressList[0];
    let hasDefaultAddress = addressList.some((item) => {
        return item.defaultFlag == true;
    });
    if (hasDefaultAddress) {
        addressList.forEach((item) => {
            if (item.defaultFlag) {
                defaultAddress = item;
                return false;
            }
        });
    }
    return defaultAddress;
}

export default {
    name: "Order",
    components: {
        HeadBar,
        CounponItem,
        EmptyData,
    },
    beforeMount() {
        this.getUserOrderDatas();
    },
    data() {
        return {
            //空优惠券icon
            emptyCouponIcon: require("@/public/images/order/empty-coupon-icon.png"),
            //空联系人icon
            emptyLinkmanIcon: require("@/public/images/order/empty-linkman-icon.png"),
            //空地址icon
            emptyAddrssIcon: require("@/public/images/order/empty-address-icon.png"),
            //空发票icon
            emptyInvoiceIcon: require("@/public/images/order/empty-invoce-icon.png"),
            //是否创建中
            isCreateIng: false,
            //商品重量
            totalWeight: 0,
            //用户留言
            message: "",
            //自定义编码
            customNumber: "",
            //优惠券是否显示
            discountSheetVisible: false,
            //优惠券列表
            couponList: [],
            //快递列表
            expressList: [],
            //快递列表是否显示
            expressSheetVisible: false,
            //是否含有发票
            hasInvoice: false,
            //是否需要发票
            needInvoice: false,
            //价格信息
            priceInfo: {
                freeShipping: false, //是否免邮
                totalPrice: 0.0, //总价
                payAmount: 0.0, //支付金额
                discountAmount: 0.0, //优惠金额
                expressAmount: 0.0, //快递费用
                freeShipperThreshold: 0, //包邮价格
                orderShipperPriceVo: {
                    expressPriceType: 0,
                },
            },
            invoiceSheetVisible: false, //发票信息上拉菜单
            //发票信息
            invoiceInfo: {},
            //发票列表
            invoiceList: [],
            distributionSheetVisible: false, //配送方式上拉菜单
            distributionTypeMap: distribution_type_map, //配送方式字典
            distributionTypeList: [
                { name: "物流快递", type: distribution_type_map.express },
                {
                    name: "送货上门",
                    subname: "",
                    type: distribution_type_map.delivery,
                },
                {
                    name: "门店自提",
                    subname: "(限华强北内)",
                    type: distribution_type_map.store,
                },
                {
                    name: "李朗自提",
                    subname: "warehouse",
                    type: distribution_type_map.warehouse,
                },
            ],
            currentDistributionType: {
                //当前用户选择配送方式,
                name: "物流快递",
                type: distribution_type_map.express,
                distributionDefaultHint: "若遇法定节假日，顺延收发货时间",
            },
            payModeSheetVisible: false, //支付模式上拉菜单
            payModeTypeList: [
                { name: "线上支付", type: 0 },
                { name: "公对公支付", subname: "(线下银行支付)", type: 1 },
            ],
            addressSheetVisible: false, //用户地址
            linkmanSheetVisible: false, //用户联系人
            userStoreSheetVisible: false, //用户店铺地址
            linkmanList: [], //联系人列表
            userAddressList: [], //用户地址列表
            userStoreList: [], //用户店铺地址
            productList: [], //商品列表
            productMinlen: min_hide_number, //是否为更多商品
            minHiderNumber: min_hide_number, //最小隐藏数
            currentLinkman: {
                //当前选择的联系人
                linkmanName: "",
                linkmanPhone: "",
            },
            currentPayMode: {
                //当前选择的支付方式
                name: "线上支付",
                type: 0,
            },
            currentUserAddress: {
                //当前用户地址
                city: "",
                cityCode: "",
                detailAddress: "",
                distributionType: "",
                district: "",
                districtCode: "",
                province: "",
                provinceCode: "",
                receiveAddressId: "",
                receiver: "",
                receiverPhone: "",
            },
            currentUserStore: {
                //当前用户店铺地址
                city: "",
                cityCode: "",
                createTime: "",
                detailAddress: "",
                distributionType: "",
                district: "",
                districtCode: "",
                province: "",
                provinceCode: "",
                receiveAddressId: "",
                receiver: "",
                receiverPhone: "",
                houseNo: "",
            },
            //当前快递信息
            currentExpressInfo: {
                isShowUrgentButton: false,
            },
            //配送时间信息
            deliveryTimeInfo: {},
            //快递类型
            expressTypeMap: express_type_map,
            //店铺配置地址
            storeInfoConfigInfo: {
                offlineStoreAddress: "",
                offlineStoreName: "",
                offlineStoreTel: "",
            },
            //是否持到付
            isFreight: false,
            //显示到付
            showFreight: false,
            //是否包含到付
            hasFreight: false,
            //是否显示加急
            showUrgen: false,
            //是否加急
            isUrgent: false,
            //快递列表是否显示
            urgentSheetVisible: false,
        };
    },
    methods: {
        goToStoreAddressEdit() {
            this.$router.push({
                path: "/user/address/doorstep",
                query: {
                    distributionType: this.currentDistributionType.type,
                },
            });
        },
        customNumberChange(value) {
            if (!isEncode(value)) {
                this.customNumber = "";
            }
        },
        isEmpty: isEmpty,
        /**
         * @description 打开发票弹窗
         */
        openInvoiceSheet() {
            let invoiceList = [...this.invoiceList];
            this.invoiceList = [];
            this.invoiceSheetVisible = true;
            window.setTimeout(() => {
                this.invoiceList = [...invoiceList];
            }, 0);
        },
        /**
         * @description 发票选项变更
         */
        invoiceSelectChange(select, invoiceInfo = {}) {
            let _this = this;
            let { invoiceId } = invoiceInfo;
            let invoiceList = [...this.invoiceList];
            let temp = [];
            invoiceList.forEach((item) => {
                if (item.invoiceId == invoiceId) {
                    item.selected = true;
                    _this.invoiceInfo = { ...item };
                    temp.unshift({ ...item });
                } else {
                    item.selected = false;
                    temp.push({ ...item });
                }
            });
            this.invoiceList = [...temp];
            this.invoiceSheetVisible = false;
        },
        /**
         * @description 设置优惠券状态
         */
        setCouponStatus() {
            this.couponList.forEach((coupon) => {
                if (coupon.disabled) {
                    this.$set(coupon, "disabled", true);
                } else {
                    this.$set(coupon, "disabled", false);
                }
            });
        },
        //获取选中的优惠券的使用id集合
        getSelectCouponIdList() {
            let temp = [];
            this.couponList.forEach((coupon) => {
                if (coupon.checkedFlag) {
                    temp.push(coupon.couponUserId);
                }
            });
            return temp;
        },
        /**
         * @description 重置优惠信息
         */
        nonuseConponInfo() {
            let _this = this;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.couponList = this.couponList.map((item) => {
                item.checkedFlag = false;
                return item;
            });
            let computedPrice = _this.computedPrice({
                productList: setProductListFieldName(
                    "productCount",
                    _this.productList
                ),
                distributionType: _this.currentDistributionType.type,
                expressId: _this.currentExpressInfo.shipperId,
                provinceCode: _this.currentUserAddress.provinceCode,
                isFreight: _this.isFreight,
                couponList: _this.getSelectCouponIdList(),
            });
            computedPrice
                .then((res) => {
                    let { data: priceInfo = {} } = res;
                    _this.priceInfo = priceInfo;
                    _this.discountSheetVisible = false;
                })
                .finally(() => {
                    this.$toast.clear();
                });
        },
        /**
         * @param {object} couponInfo 当前选择的信息
         * @description 选择优惠券
         */
        async selectCoupon(couponInfo) {
            let _this = this;
            let { disabled } = couponInfo;
            if (disabled) {
                return false;
            }
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let { data: couponData } = await this.getDiscountInfo({
                checkedState: coupon_check_status.select,
                couponIdList: _this.getSelectCouponIdList(),
                couponUserId: couponInfo.couponUserId,
                deliveryType: _this.currentDistributionType.type,
                shipperId: _this.currentExpressInfo.shipperId,
                provinceCode: _this.currentUserAddress.provinceCode,
                isFreight: _this.isFreight,
            });
            let { couponList = [] } = couponData;
            this.couponList = couponList;
            this.setCouponStatus();
            let { data: orderPriceData } = await this.computedPrice({
                distributionType: _this.currentDistributionType.type,
                expressId: _this.currentExpressInfo.shipperId,
                provinceCode: _this.currentUserAddress.provinceCode,
                couponList: _this.getSelectCouponIdList(),
                productList: setProductListFieldName(
                    "productCount",
                    _this.productList || []
                ),
                isFreight: _this.isFreight,
            });
            this.priceInfo = Object.assign(
                this.priceInfo,
                orderPriceData || {}
            );
            this.$toast.clear();
        },
        /**
         * @param {object} currentInfo 当前选择的信息
         * @description 选择送货方式
         */
        async selectDistributionType(currentInfo, isClick = false) {
            let _this = this;
            let { type, isClose = true } = currentInfo;
            if (type == this.currentDistributionType.type && isClick) return;
            if (isClose) return;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let isEmptyAddress = isEmpty(this.userAddressList);
            this.currentUserAddress.provinceCode = "";
            this.currentUserAddress.cityCode = "";
            this.currentUserAddress.districtCode = "";
            //判断是否是快递
            if (type == distribution_type_map.express) {
                //用户空地址
                if (isEmptyAddress) {
                    let { data: couponData } = await this.getDiscountInfo({
                        checkedState: coupon_check_status.optimal,
                        couponIdList: _this.getSelectCouponIdList(),
                        deliveryType: type,
                        shipperId: "",
                        provinceCode: "",
                        isFreight: false,
                    });
                    let { couponList = [] } = couponData;
                    this.couponList = couponList;
                    this.setCouponStatus();
                    let { data: orderPriceData } = await this.computedPrice({
                        distributionType: type,
                        expressId: "",
                        provinceCode: "",
                        couponList: _this.getSelectCouponIdList(),
                        productList: setProductListFieldName(
                            "productCount",
                            _this.productList || []
                        ),
                    });
                    this.priceInfo = Object.assign(
                        this.priceInfo,
                        orderPriceData || {}
                    );
                } else {
                    let defaultAddress = getDefaultAddress(
                        this.userAddressList
                    );
                    this.currentUserAddress = Object.assign(
                        {},
                        { ...defaultAddress }
                    );
                    let { data: expressList = [] } = await this.getExpressList({
                        provinceCode: defaultAddress.provinceCode,
                        cityCode: defaultAddress.cityCode,
                        districtCode: defaultAddress.districtCode,
                        distributionType: type,
                    });
                    //获取默认快递
                    let defaultExpress = getDefaultData(expressList, "default");
                    let {
                        supportPayOnDelivery: hasFreight = false,
                    } = defaultExpress;
                    this.hasFreight = hasFreight;
                    this.expressList = expressList;
                    this.currentExpressInfo = { ...defaultExpress };
                    let { data: couponData } = await this.getDiscountInfo({
                        checkedState: coupon_check_status.optimal,
                        couponIdList: _this.getSelectCouponIdList(),
                        deliveryType: type,
                        shipperId: defaultExpress.shipperId,
                        provinceCode: defaultAddress.provinceCode,
                        isFreight: false,
                    });
                    let { couponList = [] } = couponData;
                    this.couponList = couponList;
                    this.setCouponStatus();
                    let { data: orderPriceData } = await this.computedPrice({
                        distributionType: type,
                        expressId: defaultExpress.shipperId,
                        provinceCode: defaultAddress.provinceCode,
                        couponList: _this.getSelectCouponIdList(),
                        productList: setProductListFieldName(
                            "productCount",
                            _this.productList || []
                        ),
                    });
                    this.priceInfo = Object.assign(
                        this.priceInfo,
                        orderPriceData || {}
                    );
                }
            } else {
                if (type != distribution_type_map.ml) {
                    let { data: expressList = [] } = await this.getExpressList({
                        provinceCode: "",
                        cityCode: "",
                        districtCode: "",
                        distributionType: type,
                    });
                    let timerInfo = expressList[0] || {};
                    this.deliveryTimeInfo = { ...timerInfo };
                }
                let { data: couponData } = await this.getDiscountInfo({
                    checkedState: coupon_check_status.optimal,
                    couponIdList: _this.getSelectCouponIdList(),
                    deliveryType: type,
                    shipperId: "",
                    provinceCode: "",
                    isFreight: false,
                });
                let { couponList = [] } = couponData;
                this.couponList = couponList;
                this.setCouponStatus();
                let { data: orderPriceData } = await this.computedPrice({
                    distributionType: type,
                    expressId: "",
                    provinceCode: "",
                    couponList: _this.getSelectCouponIdList(),
                    productList: setProductListFieldName(
                        "productCount",
                        _this.productList || []
                    ),
                    isFreight: false,
                });
                this.priceInfo = Object.assign(
                    this.priceInfo,
                    orderPriceData || {}
                );
                this.hasFreight = false;
            }
            this.isFreight = false;
            this.showFreight = false;
            this.isUrgent = false;
            this.distributionSheetVisible = false;
            this.currentDistributionType = currentInfo;
            this.$toast.clear();
        },
        //获取店铺配置信息
        getStoreInfo() {
            return this.$axios.post(this.$api.commonApi.getStoreInfo, {});
        },
        /**
         * @param {type} 获取类型
         * @description 获取用户地址
         */
        getAddressList(type) {
            return this.$axios.post(this.$api.userApi.queryAddressListApi, {
                context: {
                    distributionType: type,
                },
                operation: "select",
            });
        },
        /**
         * @description 获取联系人
         */
        getLinkmanList() {
            return this.$axios.post(this.$api.userApi.queryLinkmanListApi, {
                operation: "select",
            });
        },
        /**
         * @description 获取订单配送方式配置
         */
        getDistributionConfigList() {
            return this.$axios.post(
                this.$api.orderApi.order_queryDistributionConfigList,
                {}
            );
        },
        /**
         * @description 获取商品列表
         */
        getCartProductList() {
            return this.$axios.post(
                this.$api.cartApi.cart_getProductSettlementList,
                {}
            );
        },
        /**
         * @description 获取发票信息
         */
        getInvoiceList() {
            return this.$axios.post(this.$api.userApi.queryInvoiceList, {
                operation: "select",
            });
        },
        /**
         * @description 获取优惠信息
         */
        getDiscountInfo(condition) {
            return this.$axios.post(this.$api.orderApi.order_getDiscountInfo, {
                orderType: SOURCE_CART,
                checkedState:
                    condition.checkedState || coupon_check_status.optimal, //类型
                couponUserId: condition.couponUserId || "",
                couponIdList: condition.couponIdList || [],
                deliveryType:
                    condition.deliveryType || distribution_type_map.express,
                shipperId: condition.shipperId || "",
                provinceCode: condition.provinceCode || "",
                isCollectPayment: condition.isFreight || false,
            });
        },
        /**
         * @description 获取用户订单所需要数据
         */
        async getUserOrderDatas() {
            let _this = this;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            //获取配送方式选择
            let distributionConfigData = await this.getDistributionConfigList();
            let { data: distributionConfigList = [] } = distributionConfigData;
            distributionConfigList = setDistributionTypeListAttrBute(
                distributionConfigList
            );
            let routeDistributionType = this.$route.query.distributionType;
            let {
                name,
                distributionDefaultHint,
                distributionType,
                invoiceDemand,
                item: defaultDistributionInfo,
            } = getDefaultDistributionInfo(distributionConfigList,routeDistributionType);
            this.distributionTypeList = [...distributionConfigList];
            this.currentDistributionType.type = distributionType;
            this.currentDistributionType.name = name;
            this.currentDistributionType.distributionDefaultHint = distributionDefaultHint;
            //获取配送方式选择
            //获取优惠信息
            let { data: couponData } = await this.getDiscountInfo({
                checkedState: coupon_check_status.optimal, //类型
                deliveryType: distributionType || distribution_type_map.express,
                isFreight: false,
            });
            let couponList = couponData.couponList || [];
            this.couponList = couponList;
            this.setCouponStatus();
            //获取优惠信息

            let { data: userAddressLists = [] } = await this.getAddressList(
                address_type_user
            );
            let { data: userStoreLists = [] } = await this.getAddressList(
                address_type_store
            );
            let { data: linkmanLists = [] } = await this.getLinkmanList();
            let { data: productData } = await this.getCartProductList();
            let { data: invoiceLists = [] } = await this.getInvoiceList();
            let { data: storeInfo = {} } = await this.getStoreInfo();
            this.storeInfoConfigInfo = { ...storeInfo };
            let productList = productData.stockHaveItems || [];
            this.userAddressList = userAddressLists;
            this.userStoreList = userStoreLists;
            this.invoiceList = setSelectedAttrBute(invoiceLists, "isDefault");
            this.linkmanList = linkmanLists;
            this.productList = checkProductHasBatch(productList);
            this.hasInvoice = !isEmpty(invoiceLists) ? true : false;
            this.needInvoice = invoiceDemand;
            if (!isEmpty(invoiceLists)) {
                this.invoiceInfo = getDefaultData(invoiceLists, "isDefault");
            }
            this.initLinkmanInfo(linkmanLists);
            this.initUserAddressInfo(userAddressLists);
            this.initUserStoreInfo(userStoreLists);
            let { data: orderPriceData } = await this.computedPrice({
                distributionType: _this.currentDistributionType.type,
                expressId: _this.currentExpressInfo.shipperId,
                provinceCode: _this.currentUserAddress.provinceCode,
                couponList: _this.getSelectCouponIdList(),
                productList: setProductListFieldName(
                    "productCount",
                    productList
                ),
            });
            this.totalWeight = orderPriceData.totalWeight || 0;
            this.priceInfo = Object.assign(
                this.priceInfo,
                orderPriceData || {}
            );
            this.$toast.clear();
            if (productList.length == 0) {
                this.$router.push("/");
                return;
            }
            this.selectDistributionType(defaultDistributionInfo);
        },
        /**
         * @description 展示更多商品
         */
        showMoreProduct() {
            if (this.productMinlen == min_hide_number) {
                this.productMinlen = this.productList.length || 0;
            } else {
                this.productMinlen = min_hide_number;
            }
        },
        /**
         * @description 初始化选择默认联系人
         */
        initLinkmanInfo(linkmanList) {
            if (!Array.isArray(linkmanList)) return [];
            let _this = this;
            linkmanList.forEach((item) => {
                if (item.defaultFlag) {
                    _this.currentLinkman = item;
                }
            });
        },
        /**
         * @description 初始化用户地址
         */
        initUserAddressInfo(addressList = []) {
            if (Array.isArray(addressList) && !isEmpty(addressList)) {
                let defaultAddress = getDefaultAddress(addressList);
                this.currentUserAddress = { ...defaultAddress };
            }
        },
        /**
         * @description 初始化用户店铺地址
         */
        initUserStoreInfo(storeList) {
            if (!Array.isArray(storeList)) return;
            let _this = this;
            storeList.forEach((item) => {
                if (item.defaultFlag) {
                    _this.currentUserStore = item;
                }
            });
        },
        /**
         * @param {object} linkmanInfo 当前选中的联系人信息
         * @description 选择联系人
         */
        selectLinkman(linkmanInfo) {
            this.currentLinkman = linkmanInfo;
            this.linkmanSheetVisible = false;
        },
        /**
         * @param {object} linkmanInfo 当前选中的联系人信息
         * @description 选择支付方式
         */
        selectPayMode(payModeInfo) {
            this.currentPayMode = payModeInfo;
            this.payModeSheetVisible = false;
        },
        /**
         * @description 选择用户地址数据
         */
        async selectUserAddress(addressInfo) {
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let _this = this;
            this.currentUserAddress = addressInfo;
            this.addressSheetVisible = false;
            let { data: expressList = [] } = await this.getExpressList({
                provinceCode: addressInfo.provinceCode,
                cityCode: addressInfo.cityCode,
                districtCode: addressInfo.districtCode,
                distributionType: _this.currentDistributionType.type,
                isFreight: false,
            });
            //获取默认快递
            let defaultExpress = getDefaultData(expressList, "default");
            let { supportPayOnDelivery: hasFreight = false } = defaultExpress;
            this.hasFreight = hasFreight;
            this.expressList = expressList;
            this.currentExpressInfo = { ...defaultExpress };
            let { data: couponData } = await this.getDiscountInfo({
                checkedState: coupon_check_status.optimal,
                couponIdList: _this.getSelectCouponIdList(),
                shipperId: defaultExpress.shipperId,
                provinceCode: addressInfo.provinceCode,
                deliveryType: _this.currentDistributionType.type,
                isFreight: false,
            });
            let { couponList = [] } = couponData;
            this.couponList = couponList;
            this.setCouponStatus();
            let { data: orderPriceData } = await this.computedPrice({
                distributionType: _this.currentDistributionType.type,
                isFreight: false,
                expressId: defaultExpress.shipperId,
                provinceCode: addressInfo.provinceCode,
                couponList: _this.getSelectCouponIdList(),
                productList: setProductListFieldName(
                    "productCount",
                    _this.productList || []
                ),
            });
            this.priceInfo = Object.assign(
                this.priceInfo,
                orderPriceData || {}
            );
            this.$toast.clear();
        },
        /**
         * @description 选择用户店铺数据
         */
        selectUserStore(storeInfo) {
            let valid_status = 1;
            let status = storeInfo.status;
            if (status !== valid_status) return;
            this.currentUserStore = storeInfo;
            this.userStoreSheetVisible = false;
        },
        /**
         * @description 选择快递
         */
        async selectExpress(expressInfo) {
            if (expressInfo.shipperId == this.currentExpressInfo.shipperId) {
                return;
            }
            let _this = this;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let { supportPayOnDelivery: hasFreight = false } = expressInfo;
            let { data: couponData } = await this.getDiscountInfo({
                checkedState: coupon_check_status.optimal,
                couponIdList: _this.getSelectCouponIdList(),
                deliveryType: _this.currentDistributionType.type,
                shipperId: expressInfo.shipperId,
                provinceCode: _this.currentUserAddress.provinceCode,
                isFreight: false,
            });
            let { couponList = [] } = couponData;
            this.couponList = couponList;
            this.setCouponStatus();
            let { data: orderPriceData } = await this.computedPrice({
                distributionType: _this.currentDistributionType.type,
                expressId: expressInfo.shipperId,
                provinceCode: _this.currentUserAddress.provinceCode,
                couponList: _this.getSelectCouponIdList(),
                productList: setProductListFieldName(
                    "productCount",
                    _this.productList || []
                ),
                isFreight: false,
            });
            this.priceInfo = Object.assign(
                this.priceInfo,
                orderPriceData || {}
            );
            this.currentExpressInfo = { ...expressInfo };
            this.deliveryTimeInfo = { ...expressInfo };
            this.hasFreight = hasFreight;
            this.expressSheetVisible = false;
            this.isFreight = false;
            this.showFreight = false;
            this.$toast.clear();
        },
        //到付更改
        async freightChange(isFreight) {
            let _this = this;
            this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            let { data: couponData } = await this.getDiscountInfo({
                checkedState: coupon_check_status.optimal,
                couponIdList: _this.getSelectCouponIdList(),
                deliveryType: _this.currentDistributionType.type,
                shipperId: _this.currentExpressInfo.shipperId,
                provinceCode: _this.currentUserAddress.provinceCode,
                isFreight: isFreight,
            });
            let { couponList = [] } = couponData;
            this.couponList = couponList;
            this.setCouponStatus();
            let { data: orderPriceData } = await this.computedPrice({
                distributionType: _this.currentDistributionType.type,
                expressId: _this.currentExpressInfo.shipperId,
                provinceCode: _this.currentUserAddress.provinceCode,
                couponList: _this.getSelectCouponIdList(),
                productList: setProductListFieldName(
                    "productCount",
                    _this.productList || []
                ),
                isFreight: isFreight,
            });
            this.priceInfo = Object.assign(
                this.priceInfo,
                orderPriceData || {}
            );
            this.isFreight = isFreight;
            this.showFreight = false;
            this.$toast.clear();
        },
        //加急更改
        urgentChange(isUrgent) {
            this.isUrgent = isUrgent;
            this.urgentSheetVisible = false;
        },
        /**
         * @description 计算价格
         */
        computedPrice(condition) {
            // provinceCode 省份code
            // expressId, 快递id
            // distributionType, 配送类型
            // couponList 优惠券
            // productList 商品列表
            if (isEmpty(condition)) return {};
            return this.$axios.post(this.$api.orderApi.order_computePrice, {
                context: {
                    provinceCode: condition.provinceCode || "",
                    expressId: condition.expressId || "",
                    distributionType:
                        condition.distributionType ||
                        distribution_type_map.express,
                    couponList: condition.couponList || [],
                    productList: condition.productList || [],
                    isPayOnDelivery: condition.isFreight || false,
                },
            });
        },
        /**
         * @param {number} provinceCode 省份编码
         * @description 获取优势快递
         */
        getExpressList(condition) {
            if (isEmpty(condition)) return {};
            let _this = this;
            const queryExpressListURL = this.$api.commonApi.getExpressList;
            return this.$axios.post(queryExpressListURL, {
                context: {
                    provinceCode: condition.provinceCode || "",
                    cityCode: condition.cityCode || "",
                    districtCode: condition.districtCode || "",
                    distributionType:
                        condition.distributionType ||
                        distribution_type_map.express,
                    totalWeight:
                        condition.totalWeight || _this.totalWeight || 0,
                },
            });
        },
        /**
         * @description 创建订单
         */
        createOrder() {
            const SOURCE_CART = 1;
            let _this = this;
            let reqData = {
                orderSource: SOURCE_CART,
                receiveId: "", //收货地址
                distributionType: "", //配送方式
                expressId: "", //快递公司
                linkmanId: "", //联系人
                payType: "", //付款类型
                isInvoice: "", //是否开发票
                invoiceId: "", //发票id
                orderRemark: "", //备注
                customNumber: "", //
                couponIdList: "", //优惠券
                provinceCode: "", //省份code
                productBaseCondList: "", //商品
                isPayOnDelivery: _this.isFreight, //是否包邮
                orderPriority: _this.isUrgent, //收否加急
            };
            let { payAmount } = this.priceInfo;
            if (payAmount <= 0) {
                Dialog.confirm({
                    title: "提示",
                    message: "实际支付为¥0,无法开票,确定要提交订单吗?",
                    confirmButtonColor: "#4BC227",
                })
                    .then(() => {
                        sumibitOrderInfo();
                    })
                    .catch(() => {});
            } else {
                sumibitOrderInfo();
            }
            /**
             * 提交订单信息
             */
            function sumibitOrderInfo() {
                if (_this.isCreateIng) return;
                _this.isCreateIng = true;
                let currentDistributionType =
                    _this.currentDistributionType.type;
                let hasInvoice = _this.hasInvoice;
                let needInvoice = _this.needInvoice;
                if (currentDistributionType == distribution_type_map.express) {
                    if (_this.userAddressList.length <= 0) {
                        _this.$toast.fail({
                            message: "请创建收货地址",
                            duration: 2000,
                        });
                        return false;
                    } else {
                        if (!_this.currentUserAddress.receiveAddressId) {
                            _this.$toast.fail({
                                message: "请选择收货地址",
                                duration: 2000,
                            });
                            return false;
                        } else {
                            if (!_this.currentExpressInfo.shipperId) {
                                _this.$toast.fail({
                                    message: "请选择快递公司",
                                    duration: 2000,
                                });
                                return false;
                            }
                            reqData.receiveId =
                                _this.currentUserAddress.receiveAddressId;
                            reqData.provinceCode =
                                _this.currentUserAddress.provinceCode;
                            reqData.expressId =
                                _this.currentExpressInfo.shipperId;
                        }
                    }
                } else if (
                    currentDistributionType == distribution_type_map.delivery
                ) {
                    if (_this.userStoreList.length <= 0) {
                        _this.$toast.fail({
                            message: "请创建店铺地址",
                            duration: 2000,
                        });
                        return false;
                    } else {
                        if (!_this.currentUserStore.receiveAddressId) {
                            _this.$toast.fail({
                                message: "请选择店铺",
                                duration: 2000,
                            });
                            return false;
                        }
                        reqData.receiveId =
                            _this.currentUserStore.receiveAddressId;
                    }
                }
                if (_this.linkmanList <= 0) {
                    _this.$toast.fail({
                        message: "请创建联系人",
                        duration: 2000,
                    });
                    return false;
                } else {
                    if (!_this.currentLinkman.linkmanId) {
                        _this.$toast.fail({
                            message: "请选择联系人",
                            duration: 2000,
                        });
                        return false;
                    }
                    reqData.linkmanId = _this.currentLinkman.linkmanId;
                }

                // if (
                //     !isEmpty(_this.customNumber) &&
                //     !isEncode(_this.customNumber)
                // ) {
                //     _this.$toast.fail({
                //         message: "请输入正确的自定订单编码",
                //         duration: 2000,
                //     });
                //     return false;
                // }

                if (hasInvoice) {
                    if (needInvoice) {
                        reqData.isInvoice = 1;
                        reqData.invoiceId = _this.invoiceInfo.invoiceId;
                        reqData.invoiceAddressId =
                            _this.invoiceInfo.addressId || "";
                    } else {
                        reqData.isInvoice = 0;
                    }
                } else {
                    reqData.isInvoice = 0;
                }
                reqData.payType = pay_type_map.online;
                reqData.orderRemark = _this.message || "";
                reqData.couponIdList = _this.getSelectCouponIdList() || [];
                reqData.distributionType = currentDistributionType;
                reqData.customNumber = _this.customNumber;
                reqData.productBaseCondList = setProductListFieldName(
                    "productCount",
                    _this.productList
                );
                _this.$toast.loading({
                    message: "提交订单中...",
                    duration: 0,
                });
                _this.$axios
                    .post(_this.$api.orderApi.order_createOrder, {
                        ...reqData,
                    })
                    .then((response) => {
                        _this.$toast.clear();
                        _this.isCreateIng = false;
                        let {
                            orderId = "",
                            orderNo = "",
                            orderPrice = 0,
                            invoiceId = "",
                        } = response.data || {};
                        if (orderPrice == 0) {
                            _this.$router.push("/pay/success");
                        } else {
                            _this.$router.push({
                                path: "/pay/select",
                                query: {
                                    orderNo: orderNo,
                                    orderId: orderId,
                                    orderPrice: orderPrice,
                                    invoiceId: invoiceId,
                                },
                            });
                        }
                    })
                    .catch((response) => {
                        let { msg = "", code = 0 } = response;
                        //库存不满足code
                        const STOCK_DISSATISFY_CODE = 1111;
                        _this.isCreateIng = false;
                        _this.$toast.clear();
                        if (code == STOCK_DISSATISFY_CODE) {
                            Dialog.confirm({
                                title: "提示",
                                message:
                                    "部分商品库存不足,请返回购物车修改商品数量",
                                confirmButtonColor: "#4BC227",
                            })
                                .then(() => {
                                    _this.$router.push("/cart");
                                })
                                .catch(() => {});
                        }
                        _this.$toast.fail({
                            message: msg,
                            duration: 2000,
                        });
                    });
            }
        },
    },
    computed: {
        /**
         * @description 计算快递显示
         */
        expressShowInfo() {},
    },
};
</script>
<style lang="less" scoped>
.order-container {
    padding: 110px 0;
}
.distribution-container {
    margin: 0 auto;
    width: 710px;
    background-color: #fff;
    .decorate-bar {
        width: 710px;
        height: 10px;
        background-image: url("../../public/images/order/distribution-type-top.png");
        background-size: 710px 10px;
        background-repeat: no-repeat;
    }
    .address-box {
        padding: 30px 0;
        &.border-bottom {
            border: 1px solid #f2f2f2;
        }
        .addrss-info {
            margin: 0 auto;
            width: 530px;
            padding: 0 100px 0 0;
            background-image: url("../../public/images/common/arrow-right-icon.png");
            background-position: center right;
            background-repeat: no-repeat;
            background-size: 40px;
            font-size: 28px;
            line-height: 1.5;
            word-break: break-all;
            text-align: justify;
        }
        .linkman-info {
            margin: 0 auto;
            width: 630px;
            font-size: 24px;
            color: #666666;
            .space-t {
                padding-left: 20px;
            }
        }
    }

    .arrival_time_info {
        overflow: hidden;
        margin: 0 auto;
        padding: 30px 0 0 0;
        width: 630px;
        border-bottom: 1px solid #f2f2f2;
        border-top: 1px solid #f2f2f2;
        > .time-hint {
            height: 80px;
            border-top: 1px solid #f2f2f2;
            font-size: 24px;
            line-height: 80px;
            text-align: center;
            color: #666;
        }
        .height-115 {
            height: 115px !important;
            min-height: 115px !important;
        }
        .info-content {
            overflow: hidden;
            padding-bottom: 30px;
            height: 165px;
        }
        .timer-left-info {
            float: left;
            width: 150px;
            min-height: 165px;
            font-size: 28px;
            display: table;
            > .info-text {
                width: 150px;
                display: table-cell;
                vertical-align: middle;
            }
        }
        .timer-right-info {
            float: right;
            width: 480px;
            font-size: 26px;
            text-align: right;
            color: #666;
            > .time-info-space {
                margin-bottom: 5px;
            }
        }
    }

    .express-hint {
        height: 80px;
        font-size: 24px;
        line-height: 80px;
        text-align: center;
        color: #666;
    }

    .express-info-box {
        overflow: hidden;
        margin: 0 auto;
        padding: 30px 0 0 0;
        width: 630px;
        border-bottom: 1px solid #f2f2f2;
        border-top: 1px solid #f2f2f2;
        .info-content {
            overflow: hidden;
            padding-bottom: 30px;
            min-height: 140px;
        }
        .express-left-info {
            float: left;
            width: 200px;
            min-height: 140px;
            font-size: 28px;
            display: table;
            > .info-text {
                width: 200px;
                display: table-cell;
                vertical-align: middle;
            }
        }
        .express-right-info {
            float: right;
            width: 430px;
            font-size: 26px;
            text-align: right;
            color: #666;
            > .exporess-info-space {
                margin-bottom: 5px;
            }
            .orgin-color {
                font-style: normal;
                color: #ff5500;
            }
        }
    }

    .urgent-info-box {
        overflow: hidden;
        margin: 0 auto;
        padding: 30px 0 0 0;
        width: 630px;
        border-bottom: 1px solid #f2f2f2;
        border-top: 1px solid #f2f2f2;
        .info-content {
            overflow: hidden;
            padding-bottom: 30px;
            min-height: 140x;
        }
        .express-left-info {
            float: left;
            width: 260px;
            min-height: 140px;
            font-size: 28px;
            display: table;
            > .info-text {
                width: 260px;
                display: table-cell;
                vertical-align: middle;
            }
        }
        .express-right-info {
            float: right;
            padding-right: 40px;
            width: 330px;
            font-size: 26px;
            text-align: right;
            color: #666;
            background-image: url("../../public/images/common/arrow-right-icon.png");
            background-position: center right;
            background-repeat: no-repeat;
            background-size: 40px;
            > .exporess-info-space {
                margin-bottom: 5px;
            }
            .orgin-color {
                font-style: normal;
                color: #ff5500;
            }
        }
    }
}
.meuns-container {
    margin: 20px auto;
    width: 710px;
    background-color: #fff;
}
.menu-item {
    overflow: hidden;
    margin: 0 auto;
    width: 630px;
    height: 110px;
    border-bottom: 1px solid #f2f2f2;
    &.border-top {
        border-top: 1px solid #f2f2f2;
    }
    &.none-border-bottom {
        border-bottom: none;
    }
    .meun-left {
        float: left;
        width: 315px;
        height: 115px;
        font-size: 28px;
        line-height: 115px;
        color: #333;
    }
    .meun-right {
        float: right;
        padding-right: 40px;
        width: 275px;
        height: 110px;
        background-image: url("../../public/images/common/arrow-right-icon.png");
        background-position: center right;
        background-repeat: no-repeat;
        background-size: 40px;
        font-size: 26px;
        line-height: 110px;
        text-align: right;
        color: #666;
    }
}
.message-container {
    margin: 0 auto 20px;
    padding-left: 10px;
    width: 700px;
    background-color: #fff;
    .codes_text {
        margin: 0 auto;
        padding: 20px 0px;
        width: 630px;
        border-top: 1px solid #f2f2f2;
        font-size: 24px;
        color: #666;
        text-align: center;
    }
}
.product-container {
    margin: 0 auto;
    width: 710px;
    background-color: #fff;
    .product-list {
        margin: 0 auto;
        width: 630px;
        .product-item {
            overflow: hidden;
            padding: 30px 0;
            border-bottom: 1px solid #f2f2f2;
            .product-name {
                font-size: 26px;
                word-break: break-all;
                line-height: 32px;
                color: #333;

                .lable-item {
                    margin-right: 5px;
                    *display: inline;
                    display: inline-block;
                    zoom: 1;
                    height: 40px;
                    padding: 0 15px;
                    font-size: 24px;
                    line-height: 40px;
                }
                > .discount-tag {
                    *display: inline;
                    display: inline-block;
                    margin-left: 10px;
                    padding: 2px 4px;
                    zoom: 1;
                    background-color: #fef5e5;
                    font-size: 20px;
                    color: #ff8f00;
                }
            }
            .product-param {
                font-size: 24px;
                word-break: break-all;
                line-height: 1.5;
                color: #999999;
                > .batch {
                    padding-left: 20px;
                }
            }
            .product-price-info {
                overflow: hidden;
                margin-top: 5px;
                > .info-1 {
                    float: left;
                    width: 30%;
                    font-size: 24px;
                    color: #666;
                    em {
                        padding-right: 20px;
                    }
                }
                > .info-2 {
                    float: right;
                    width: 40%;
                    font-size: 28px;
                    text-align: right;
                    color: #333;
                }
            }
        }
        li:last-child {
            border: none;
        }
    }
    .product-more {
        margin: 0 auto;
        width: 630px;
        height: 60px;
        border-top: 1px solid #f2f2f2;
        font-size: 24px;
        line-height: 60px;
        text-align: center;
        color: #999;
        .more-arrow-icon {
            *display: inline;
            zoom: 1;
            display: inline-block;
            vertical-align: middle;
            margin-left: 0px;
            width: 40px;
            height: 40px;
            background-image: url("../../public/images/common/arrow-bottom-icon.png");
            background-repeat: no-repeat;
            background-position: center;
            background-size: 40px;
            &.up-arrow-icon {
                background-image: url("../../public/images/common/arrow-top-icon.png");
            }
        }
    }
}
.price-container {
    margin: 20px auto 0;
    width: 710px;
    padding: 20px 0;
    background-color: #fff;
    .price-item {
        overflow: hidden;
        margin: 0 auto;
        width: 630px;
        > div {
            font-size: 28px;
            line-height: 60px;
            color: #333;
        }
        .price-info-name {
            float: left;
            width: 315px;
            height: 60px;
        }
        .price-number {
            float: right;
            width: 315px;
            height: 60px;
            text-align: right;
        }
    }
}
.user-address-list {
    padding: 0 20px;
    .address-item {
        padding: 20px 0px;
        .addrss-info {
            margin: 0 auto;
            font-size: 28px;
            line-height: 1.5;
            word-break: break-all;
        }
        .linkman-info {
            margin: 0 auto;
            font-size: 24px;
            color: #666666;
            .space-t {
                padding-left: 20px;
            }
        }
    }
}
.linkman-list {
    padding: 0 20px;
    .linkman-item {
        height: 100px;
        border-bottom: 1px;
        font-size: 28px;
        line-height: 100px;
        font-size: 28px;
        color: #333;
        em {
            padding-left: 20px;
        }
    }
}
.coupon-list {
    margin: 0 auto;
    padding: 0 20px;
    width: 710px;
    background-color: #f6f6f6;
}
.express-sheet-box {
    padding: 0 20px;
    .express-distount-info {
        padding: 10px 0;
        font-size: 28px;
        color: #333;
    }
    .express-data-list {
        .express-item {
            height: 100px;
            border-top: 1px solid #f2f2f2;
            line-height: 100px;
            font-size: 28px;
            color: #333;
        }
    }
}
.invoice-info-box {
    margin: 0 auto;
    padding: 0 30px;
    width: 690px;
    &.padding_bottom {
        padding-bottom: 30px;
    }
    .invoce-select {
        margin-top: 20px;
        font-size: 0;
        > .select-item {
            *display: inline;
            display: inline-block;
            zoom: 1;
            width: 168px;
            height: 76px;
            border: 1px solid #dedede;
            font-size: 28px;
            line-height: 76px;
            text-align: center;
            &.active {
                border-color: #4bc227;
                background-color: #f3fff0;
                color: #4bc227;
            }
            &.margin-right {
                margin-right: 20px;
            }
        }
    }
    .invoice-info-list {
        margin: 0 auto;
        width: 690px;
        overflow: hidden;
        .invoice-info-ul {
            margin: 0 auto;
            width: 690px;
            .invoice-info-item {
                padding: 40px 0;
                width: 690px;
                overflow: hidden;
                border-bottom: 2px solid #f2f2f2;
                > .icon {
                    position: relative;
                    float: left;
                    width: 100px;
                    .icon-wrap {
                        margin-top: 25px;
                        margin-left: 10px;
                        width: 40px;
                        height: 40px;
                    }
                }
                > .invoice-text {
                    font-size: 24px;
                    width: 580px;
                    float: right;
                    > .company-name {
                        .default-icon {
                            *display: inline;
                            display: inline-block;
                            zoom: 1;
                            margin-left: 20px;
                            padding: 2px 10px;
                            background-color: #6ab0f7;
                            font-size: 12px;
                            color: #fff;
                            font-style: normal;
                        }
                    }
                    > .tax-number {
                        padding-top: 22px;
                        color: #999;
                    }
                }
            }
        }
    }
}
.btn-group {
    padding: 0 30px;
    &.margin-top {
        margin-top: 20px;
    }
    .btn-item {
        height: 70px;
        background-color: @theme-color;
        border-radius: 40px;
        line-height: 70px;
        font-size: 28px;
        text-align: center;
        color: #fff;
        &.margin-top {
            margin-top: 20px;
        }
        &.margin-bottom {
            margin-bottom: 20px;
        }
    }
}
.settlement-bar {
    position: fixed;
    left: 50%;
    margin-left: -375px;
    bottom: 0px;
    width: 750px;
    height: 100px;
    background-color: #fff;
    > .price-info {
        float: left;
        padding-left: 55px;
        width: 455px;
        height: 100px;
        line-height: 100px;
        .t-1 {
            font-size: 24px;
            color: #333;
        }
        .t-2 {
            padding: 0 5px;
            font-size: 24px;
            color: #ff5500;
        }
        .t-3 {
            font-size: 32px;
            color: #ff5500;
        }
    }
    > .sumbit-btn {
        float: right;
        width: 240px;
        height: 100px;
        background-color: @theme-color;
        font-size: 32px;
        line-height: 100px;
        text-align: center;
        color: #fff;
    }
}

.common-btn {
    margin: 20px auto;
    width: 690px;
    height: 70px;
    background-color: @theme-color;
    border-radius: 40px;
    font-size: 28px;
    line-height: 70px;
    text-align: center;
    color: #fff;
}

.message-container {
    margin-bottom: 20px;

    .van-cell {
        font-size: 24px;

        /deep/ .van-field__label {
            width: 200px;
            font-size: 28px;
            color: #333;
        }
    }
}
</style>
